/**
 * uc-gallery.js – thumbnail → main image swapping on product page.
 * Subtle fade transition (CSS, respects prefers-reduced-motion).
 * Keyboard: Arrow keys move focus and swap media; Enter/Space activate.
 * Event delegation from .product__media (contains .uc-gallery and .uc-thumb).
 */
(function () {
  function activateIndex(container, index) {
    var gallery = container.querySelector(".uc-gallery");
    if (!gallery) return;

    var mediaItems = gallery.querySelectorAll(".uc-media");
    var thumbs = container.querySelectorAll(".uc-thumb");

    mediaItems.forEach(function (el) {
      el.classList.remove("is-active");
    });
    thumbs.forEach(function (el) {
      el.classList.remove("is-active");
      el.removeAttribute("aria-current");
    });

    var activeMedia = gallery.querySelector(
      '.uc-media[data-uc-media-index="' + index + '"]'
    );
    var activeThumb = container.querySelector(
      '.uc-thumb[data-uc-media-index="' + index + '"]'
    );
    if (activeMedia) activeMedia.classList.add("is-active");
    if (activeThumb) {
      activeThumb.classList.add("is-active");
      activeThumb.setAttribute("aria-current", "true");
    }
  }

  function onKeydown(e) {
    var thumb =
      (e.target && e.target.closest && e.target.closest(".uc-thumb")) ||
      (document.activeElement &&
        document.activeElement.closest &&
        document.activeElement.closest(".uc-thumb"));
    if (!thumb) return;

    var container = thumb.closest(".product__media");
    if (!container) return;

    var thumbs = container.querySelectorAll(".uc-thumb");
    var list = Array.prototype.slice.call(thumbs);
    var i = list.indexOf(thumb);
    if (i === -1) return;

    var key =
      e.key ||
      (e.keyCode === 39
        ? "ArrowRight"
        : e.keyCode === 40
          ? "ArrowDown"
          : e.keyCode === 37
            ? "ArrowLeft"
            : e.keyCode === 38
              ? "ArrowUp"
              : "");

    if (key === "ArrowRight" || key === "ArrowDown") {
      e.preventDefault();
      e.stopPropagation();
      var next = list[(i + 1) % list.length];
      next.focus();
      activateIndex(container, next.getAttribute("data-uc-media-index"));
    } else if (key === "ArrowLeft" || key === "ArrowUp") {
      e.preventDefault();
      e.stopPropagation();
      var prev = list[i === 0 ? list.length - 1 : i - 1];
      prev.focus();
      activateIndex(container, prev.getAttribute("data-uc-media-index"));
    } else if (key === "Enter" || key === " ") {
      e.preventDefault();
      e.stopPropagation();
      activateIndex(container, thumb.getAttribute("data-uc-media-index"));
    }
  }

  function onClick(e) {
    var thumb = e.target.closest(".uc-thumb");
    if (!thumb) return;

    var container = thumb.closest(".product__media");
    if (!container) return;

    var index = thumb.getAttribute("data-uc-media-index");
    if (index == null) return;

    activateIndex(container, index);
  }

  function init() {
    var containers = document.querySelectorAll(".product__media");
    containers.forEach(function (container) {
      if (!container.querySelector(".uc-gallery") || !container.querySelector(".uc-thumb")) return;
      container.addEventListener("click", onClick);
      container.addEventListener("keydown", onKeydown);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
